// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { Duration } from 'luxon';
import type { PartialDeep } from 'type-fest';

import * as DateHelpers from '../../../utils/dateHelpers';
import type { ExcludeMethodsDeep } from '../../../utils/types';

export class TripDuration {
  readonly value: Duration;
  readonly text: string;

  constructor(data: { [key: string]: any } = {}) {
    this.value = DateHelpers.ParseServerDuration(data.value);
    this.text = data.text === undefined ? '' : data.text;
  }

  static zero(): TripDuration {
    const zeroValues: ExcludeMethodsDeep<TripDuration> = {
      value: DateHelpers.ParseServerDuration(DateHelpers.ZERO_DURATION_STRING),
      text: '',
    };
    return new TripDuration(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type TripDurationWireFormat = {
  value: string;
  text: string;
};

type NewTripDurationProps = PartialDeep<TripDuration, { recurseIntoArrays: true }>;
export const NewTripDuration: (props: NewTripDurationProps) => TripDuration = (props) =>
  new TripDuration(props);

type NewTripDurationFromWireFormatProps = PartialDeep<
  TripDurationWireFormat,
  { recurseIntoArrays: true }
>;
export const NewTripDurationFromWireFormat: (
  props: NewTripDurationFromWireFormatProps,
) => TripDuration = (props) => new TripDuration(props);
